import React from 'react';
import { Alert } from 'react-bootstrap';
import { Query } from '@apollo/client/react/components';
import { useSelector } from 'react-redux';
import SlidingPane from 'react-sliding-pane';
import 'react-sliding-pane/dist/react-sliding-pane.css';
import { getOwnersByDept } from '../api';
import { Loader } from '../../../components/Loader';
import { CapitalProgressByOwner } from './CapitalProgressByOwner';
import { DefaultProgressByOwner } from './DefaultProgressByOwner';

export const ProgressByOwner = (props: any) => {
  const { user } = useSelector((state: any) => ({ user: state.user }));

  const renderAlert = () => {
    if (user.currentRole.source === 'Capital') {
      return (
        <Alert variant='warning'>
          Note - Physical owner charts may not fully represent Capital inventory due to each department's inventory being assigned by department
          abbreviation from EOne and not by physical owner. Please check the Inventory tab to be sure all Capital inventory is complete for your
          department.
        </Alert>
      );
    }
  };

  return (
    <SlidingPane style={{ zIndex: 100 }} isOpen={props.isOpen} width='450px' title='Progress by Physical Owner' onRequestClose={props.toggleOpen}>
      {renderAlert()}
      <Query query={getOwnersByDept(props.departmentId)}>
        {({ loading, error, data }: any) => {
          if (loading) return <Loader />;
          if (error) return <div>{JSON.stringify(error)}</div>;
          if (data) {
            if (user.currentRole.source === 'Capital') return <CapitalProgressByOwner data={data} />;
            return <DefaultProgressByOwner data={data} />;
          }
          return null;
        }}
      </Query>
    </SlidingPane>
  );
};
